/**
 * MD-14 FE-LANDINGS — OG image config
 *
 * Day-1 = static SVG-to-PNG generated at build time, served from Pages /og/.
 * This module exposes the metadata + URL builder used by SSR `<head>` and
 * unit tests asserting cardinality (4 variants).
 */

import type { LandingSlug } from '../../i18n/landing-types';

export type OGImage = {
  slug: LandingSlug;
  url: string;
  width: 1200;
  height: 630;
  alt: string;
};

export const OG_BASE_PATH = '/og';
export const OG_VERSION = '1.0';

export function ogImageUrl(slug: LandingSlug, baseHost: string = 'https://asklaw.vn'): string {
  return `${baseHost}${OG_BASE_PATH}/${slug}.png?v=${OG_VERSION}`;
}

export function ogImageMeta(
  slug: LandingSlug,
  baseHost: string = 'https://asklaw.vn'
): OGImage {
  const altByLanding: Record<LandingSlug, string> = {
    universal: 'Asklaw — AI Legal Copilot Việt Nam',
    expat: 'Asklaw for expats — Vietnam visa, TRC, work permit',
    sme: 'Asklaw — Tư vấn pháp lý cho SME Việt Nam',
    citizen: 'Asklaw — Pháp luật cho người dân Việt Nam',
  };
  return {
    slug,
    url: ogImageUrl(slug, baseHost),
    width: 1200,
    height: 630,
    alt: altByLanding[slug],
  };
}

export function allOgImages(baseHost: string = 'https://asklaw.vn'): OGImage[] {
  const slugs: LandingSlug[] = ['universal', 'expat', 'sme', 'citizen'];
  return slugs.map((s) => ogImageMeta(s, baseHost));
}
